module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0075.jpg?v=5b14c133";